/**
 * Date-extensions locale Greek [el]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('el', {
    monthNames: ['Ιανουάριος','Φεβρουάριος','Μάρτιος','Απρίλιος','Μάιος','Ιούνιος','Ιούλιος','Αύγουστος','Σεπτέμβριος','Οκτώβριος','Νοέμβριος','Δεκέμβριος'],
    monthShortNames: ['Ιαν','Φεβ','Μαρ','Απρ','Μαϊ','Ιουν','Ιουλ','Αυγ','Σεπ','Οκτ','Νοε','Δεκ'],
    dayNames: ['Κυριακή','Δευτέρα','Τρίτη','Τετάρτη','Πέμπτη','Παρασκευή','Σάββατο'],
    dayShortNames: ['Κυρ','Δευ','Τρι','Τετ','Πεμ','Παρ','Σαβ']
});
